"use strict";import{RadioGroup as o}from"./src/RadioGroup.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-radio-group",o);
//# sourceMappingURL=sp-radio-group.js.map
